//
document.addEventListener("DOMContentLoaded", () => {
  const mobileBreakpoint = 768;

  const toggleDropdown = (event) => {
    if (window.innerWidth <= mobileBreakpoint) {
      const dropdownItem = event.target.closest(".dropdown-item"); // Ensure the clicked item is targeted
      const subList = dropdownItem.nextElementSibling; // Sibling `.sub_list_item`

      // Close all open dropdowns except the one clicked
      document.querySelectorAll(".dropdown-item.open").forEach((item) => {
        if (item !== dropdownItem) {
          item.classList.remove("open");
          const siblingSubList = item.nextElementSibling;
          if (
            siblingSubList &&
            siblingSubList.classList.contains("sub_list_item")
          ) {
            siblingSubList.classList.remove("show");
          }
        }
      });

      // Toggle `open` on the clicked `.dropdown-item`
      dropdownItem.classList.toggle("open");

      // Toggle `show` on the sibling `.sub_list_item`
      if (subList && subList.classList.contains("sub_list_item")) {
        subList.classList.toggle("show");
      }
    }
  };

  const closeAllDropdowns = (event) => {
    if (window.innerWidth <= mobileBreakpoint) {
      // Check if the click is outside any `.dropdown-item`
      if (!event.target.closest(".dropdown-item")) {
        document.querySelectorAll(".dropdown-item.open").forEach((item) => {
          item.classList.remove("open");
          const siblingSubList = item.nextElementSibling;
          if (
            siblingSubList &&
            siblingSubList.classList.contains("sub_list_item")
          ) {
            siblingSubList.classList.remove("show");
          }
        });
      }
    }
  };

  const dropdownItems = document.querySelectorAll(".sub_list > .dropdown-item");
  dropdownItems.forEach((item) => {
    item.addEventListener("click", toggleDropdown);
  });

  // Close dropdowns when clicking outside
  document.addEventListener("click", closeAllDropdowns);

  // Cleanup when resizing out of mobile view
  window.addEventListener("resize", () => {
    if (window.innerWidth > mobileBreakpoint) {
      document.querySelectorAll(".dropdown-item.open").forEach((item) => {
        item.classList.remove("open");
      });
      document.querySelectorAll(".sub_list_item.show").forEach((subList) => {
        subList.classList.remove("show");
      });
    }
  });
});

// Disable browser's default scroll restoration
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

// Set scroll position to top on page load
window.onload = function () {
  window.scrollTo(0, 0);
};

//

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 100) {
    $(".header_sticky").addClass("active");
  } else {
    $(".header_sticky").removeClass("active");
  }
});

//

const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);
